import { render } from "./SignUpPage.vue?vue&type=template&id=1a5e98fc&scoped=true&ts=true&lang=pug"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"

import "./SignUpPage.vue?vue&type=style&index=0&id=1a5e98fc&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/WP Darts/Admin Webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5e98fc"]])

export default __exports__